import { motion } from "framer-motion";

const pillars = [
  {
    num: "01",
    title: "Maîtriser votre budget",
    text: "Estimez votre capacité d'emprunt, anticipez les frais cachés (notaire, raccordements, aménagement) et évitez les dérapages qui coûtent des milliers d'euros.",
  },
  {
    num: "02",
    title: "Maîtriser votre recherche",
    text: "Terrain plat ou en pente, viabilité, vis-à-vis, règles d'urbanisme : apprenez à repérer le bon terrain avant de signer le compromis.",
  },
  {
    num: "03",
    title: "Maîtriser votre projet",
    text: "Du permis de construire à la réception des travaux, suivez chaque étape dans le bon ordre et dialoguez d'égal à égal avec les professionnels.",
  },
];

export default function Manifesto() {
  return (
    <section className="bg-olive text-bone py-24 lg:py-32" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-sub text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-bone/60 mb-16"
        >
          Les trois piliers d'un projet réussi
        </motion.p>
        <div>
          {pillars.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="grid grid-cols-12 gap-6 items-start border-t border-bone/15 py-10 lg:py-14"
              data-testid={`pillar-${p.num}`}
            >
              <span className="col-span-3 lg:col-span-2 font-display text-6xl lg:text-8xl text-bone/25 leading-none">
                {p.num}
              </span>
              <h3 className="col-span-9 lg:col-span-4 font-display text-2xl sm:text-3xl lg:text-4xl leading-snug">
                {p.title}
              </h3>
              <p className="col-span-9 col-start-4 lg:col-span-5 lg:col-start-8 text-sm sm:text-base leading-relaxed text-bone/70">
                {p.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
